<template>
  <div class="blackout-sober button anton">
    <button v-if="type == 'button'" @click="callback($event)" :tabindex="tabindex">
      <span>{{ $t(cta) }}</span>
    </button>

    <router-link v-else-if="type == 'router'" :to="$i18nRoute(routeObject)" :tabindex="tabindex">
      <span>{{ $t(cta) }}</span>
    </router-link>

    <a v-if="type == 'link'" :href="route" :tabindex="tabindex">
      <span>{{ $t(cta) }}</span>
    </a>
  </div>
</template>

<script>

export default {
  name: 'AppButton',
  props: ['cta', 'type', 'route', 'slug', 'tabindex'],
  methods: {
    callback(e) {
      this.$emit('click', e)
    }
  },
  computed: {
    routeObject() {
      let obj = {
        name: this.route
      }

      if(this.slug) {
        obj.params = {slug: this.slug};
      }

      return obj;
    }
  }
};
</script>

<style lang="scss" >
.button{

  button,
  a {
    width: 100%;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    color: #fff;
    font-size: 16px;
    letter-spacing: 2px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 3;

    @include bp($bp--m) {
      font-size: 30px;
    }

    span {
      position: relative;
      z-index: 4;
    }
  }

  &-red-large,
  &-red-medium,
  &-red-small {

    button,
    a {
      padding: 20px 40px;
      background-image: url('~@/assets/images/red-large-btn.png'), url('~@/assets/images/red-large-btn-over.png');
      background-repeat: repeat-x;
      background-size: contain;
      font-size: 24px;
      color: $darkBlue;
      text-shadow: 1px 1px 0 rgba(255,255,255,0.5);
      border-radius: 5px;

      &:hover {
        background-image: url('~@/assets/images/red-large-btn-over.png');
      }

      span {
        position: relative;
        top: -2px;
      }

      @include bp($bp--m) {
        font-size: 38px;

        span {
          position: relative;
          top: -4px;
        }
      }


    }
  }

  &-red-medium {
    button,
    a {
      background-size: 100% 100%;
    }
  }

  &-red-small {

    button,
    a {
      padding: 10px;
      font-size: 16px;
      color: #ffffff;
      text-shadow: none;
      background-size: cover;

      @include bp($bp--m) {
        font-size: 20px;
      }

      span {
        position: relative;
        top: -2px;
      }
    }
  }

  &-blue-rounded {

    button,
    a {
      background: none;
      padding: 10px 0;
      text-shadow: 1px 1px 1px rgba(0,0,0,0.8);

      background-image: url('~@/assets/images/blue-rounded-middle.png');
      background-repeat: repeat-x;
      background-size: contain;
      min-width: auto;
      position: relative;

      @include bp($bp--m) {
        min-width: 125px;
      }

      &:before,
      &:after {
        width: 19px;
        height: 100%;
        content: '';
        position: absolute;
        top:0;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: 0 0;

        @include bp($bp--m) {
          width: 26px;
        }
      }

      &:before {
        left: -18px;
        background-image: url('~@/assets/images/blue-rounded-left.png');

        @include bp($bp--m) {
          left: -21px;
        }
        @include bp($bp--l) {
          left: -22px;
        }
      }

      &:after {
        right: -18px;
        background-image: url('~@/assets/images/blue-rounded-right.png');

        @include bp($bp--m) {
          right: -25px;
        }
        @include bp($bp--l) {
          right: -26px;
        }
      }

      &:hover {
        background-image: url('~@/assets/images/blue-rounded-middle-over.png');

        &:before {
          background-image: url('~@/assets/images/blue-rounded-left-over.png');
        }
        &:after {
          background-image: url('~@/assets/images/blue-rounded-right-over.png');
        }
      }

      @include bp($bp--m) {
        font-size: 22px;

        span {
          position: relative;
          top: -2px;
        }
      }
    }
  }

  &.join-up-btn {
    button,
    a {
      font-size: 20px;
      html[lang="no"] & {
         @include bp($bp--l, false) {
          font-size: 15px;
          position: relative;
          top: 6px;
         }
        }
    }
  }

  &.button-inline {

    button,
    a {
      font-size: 16px;
      background: none;

      @include bp($bp--m) {
        font-size: 18px;
      }
    }
  }
}

// locale button override
body section.ar,
body section.ko {
  .button {
    &-blue-rounded {
      button,
      a {
        padding: 7px 0;

        @include bp($bp--m) {
          padding: 10px 0;
        }
      }
    }
  }
}
body section.ja {
  .button {
    &-blue-rounded {
      button,
      a {
        padding: 5px 0;
      }
    }
  }
}
body section.ru {
  .button {
    &-blue-rounded {
      button,
      a {
        padding: 8px 0;
      }
    }
  }
}
body section.tw,
body section.zh {
  .button {
    &-blue-rounded {
      button,
      a {
        span {
          top: -3px;
        }
      }
    }
  }
}
body section.fr {
  .button {
    &-blue-rounded {
      button,
      a {
        min-width: 125px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/AppButton.vue